module.exports = __webpack_public_path__ + "static/media/ePosterRestaurant.a62ecec8.jpg";